import { defineComponent, openBlock, createBlock, unref, withCtx, createVNode, createElementVNode, createElementBlock, Fragment, renderList, toDisplayString } from "vue";
import { useDatePickerContext, DatePickerView, DatePickerTableCell, DatePickerTableCellTrigger } from "@ark-ui/vue/date-picker";
import { formatWeekDayLabel } from "../formatWeekDayLabel.js";
import Header from "./Header.vue.js";
const _hoisted_1 = { class: "elfie-datepicker__table" };
const _hoisted_2 = { class: "elfie-datepicker__day-cell-inner elfie-datepicker__day-cell-inner--in-the-last" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "DayViewInTheLast",
  setup(__props) {
    const datePicker = useDatePickerContext();
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(DatePickerView), { view: "day" }, {
        default: withCtx(() => [
          createVNode(Header),
          createElementVNode("table", _hoisted_1, [
            createElementVNode("thead", null, [
              createElementVNode("tr", null, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(unref(datePicker).weekDays, (weekDay, id) => {
                  return openBlock(), createElementBlock("th", {
                    key: id,
                    class: "elfie-datepicker__table-header-cell"
                  }, toDisplayString(unref(formatWeekDayLabel)(weekDay)), 1);
                }), 128))
              ])
            ]),
            createElementVNode("tbody", null, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(unref(datePicker).weeks, (week, weekId) => {
                return openBlock(), createElementBlock("tr", { key: weekId }, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(week, (day, dayId) => {
                    return openBlock(), createElementBlock("td", {
                      key: dayId,
                      class: "elfie-datepicker__table-cell"
                    }, [
                      createVNode(unref(DatePickerTableCell), { value: day }, {
                        default: withCtx(() => [
                          createVNode(unref(DatePickerTableCellTrigger), { class: "elfie-datepicker__day-cell elfie-datepicker__day-cell--in-the-last" }, {
                            default: withCtx(() => [
                              createElementVNode("span", _hoisted_2, toDisplayString(day.day), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["value"])
                    ]);
                  }), 128))
                ]);
              }), 128))
            ])
          ])
        ]),
        _: 1
      });
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=DayViewInTheLast.vue2.js.map
